<template>
  <div
      v-if="visible"
      class="fixed top-0 left-0 right-0 bottom-0 z-40"
      style="background: rgba(0, 0, 0, 0.8)"
  >
    <div
        class="z-50 p-4 absolute left-1/2 top-1/2 transform -translate-x-2/4 -translate-y-2/4 bg-white rounded"
        style="box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15); width: 640px;"
        ref="contentRef"
    >
      <div class="relative">
        <span
            class="absolute -top-6 right-0 cursor-pointer"
            @click="hide"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </span>
        <form>
          <b-form-group :name="actions === 'edit' ? $t('text.edit') : $t('text.add_new_bank')">
            <b-select class="mt-4" :label="$t('fields.bank')"
                      v-model="state.formData.bank_id"
                      :options="banks"
                      key="name"
                      label-field="bank_name"
                      :errorMessage="messageError.bank_id"
            />
            <b-input class="mt-4" :label="$t('fields.account_number')" type="number"
                     v-model="state.formData.bank_account_number"
                     :errorMessage="messageError.bank_account_number"
            />
            <b-input class="mt-4" :label="$t('fields.account_name')"
                     type="text"
                     v-model="state.formData.bank_account_name"
                     :errorMessage="messageError.bank_account_name"
            />

            <b-input class="mt-4" :label="$t('fields.branch')"
                     type="text"
                     v-model="state.formData.bank_branch"
                     :errorMessage="messageError.bank_branch"
            />
          </b-form-group>
          <div v-if="failed" class="mx-3 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
               role="alert">
            <span class="block sm:inline">{{ failed }}</span>
          </div>
          <div class="w-full px-3 mt-6 flex items-center justify-end">
            <button
                class="py-3 px-4 text-center bg-indigo-900 w-1/3 rounded-md text-white text-sm hover:bg-indigo-900"
                @click.prevent="submitForm"
            >
              {{ $t('text.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  computed,
} from 'vue'
import BInput from '../../components/Form/BInput.vue'
import BFormGroup from '../../components/Form/BFormGroup.vue'
import BSelect from '../../components/Form/BSelect.vue'
import {useStore} from 'vuex'
import bankApis from '../../api/bank'
import { useI18n } from "vue-i18n";
import _ from "lodash";
import {useToast} from "vue-toastification";

  export default defineComponent({
    name: 'DialogCreateBank',
    components: {
      BInput,
      BFormGroup,
      BSelect
    },
    setup() {
      const state = reactive({
        formData: {
          id: '',
          bank_id: null,
          bank_account_number: '',
          bank_account_name: '',
          bank_branch: '',
          default: 0
        }
      })
      const failed = ref(false);
      const toast = useToast();
      const { t } = useI18n({ useScope: "global" });
      const messageError = ref({});
      const store = useStore();
      const user = computed(() => store.state.user.userInfo)
      const banks = ref([]);

      const validate = function () {
        let isValid = true;
        if (!state.formData.bank_account_number || !state.formData.bank_account_number.toString().trim()) {
          isValid = false;
          messageError.value.bank_account_number = t("errors.required");
        }
        else {
          if (state.formData.bank_account_number.length < 1 || state.formData.bank_account_number.length >= 50) {
            isValid = false;
            messageError.value.bank_account_number = t("errors.limit_bank_characters");
          }
          else{
            messageError.value.bank_account_number = "";
          }
        }
        if (!state.formData.bank_account_name || !state.formData.bank_account_name.toString().trim()) {
          isValid = false;
          messageError.value.bank_account_name = t("errors.required");
        }
        else {
          if (state.formData.bank_account_name.length < 1 || state.formData.bank_account_name.length >= 50) {
            isValid = false;
            messageError.value.bank_account_name = t("errors.limit_bank_characters");
          }
          else{
            messageError.value.bank_account_name = "";
          }
        }
        if (!state.formData.bank_branch || !state.formData.bank_branch.toString().trim()) {
          isValid = false;
          messageError.value.bank_branch = t("errors.required");
        }
        else {
          if (state.formData.bank_branch.length < 1 || state.formData.bank_branch.length >= 50) {
            isValid = false;
            messageError.value.bank_branch = t("errors.limit_bank_characters");
          }
          else{
            messageError.value.bank_branch = "";
          }
        }
        if (!state.formData.bank_id || !state.formData.bank_id.toString().trim()) {
          isValid = false;
          messageError.value.bank_id = t("errors.required");
        }
        else {
          messageError.value.bank_id = "";
        }
        return isValid;
      }
      const visible = ref(false)
      const hide = () => {
        resetFormData()
        visible.value = false
      }
      const actions = ref('')
      const setupDialog = async (actionsName, payload) => {
        const { data } = await bankApis.getAllBank(``);
        data.data.forEach((item) => item.bank_name =  item.sort_name +' - '+ item.name);
        banks.value = data.data;
        data.data.sort(function (a, b) {
          return a.sort_name.localeCompare(b.sort_name);
        })
        actions.value = actionsName
        if (actionsName === 'edit') {
          state.formData = {...payload}
        } else {
          if(payload > 0) {
            state.formData.default = 0
          } else {
            state.formData.default = 1
          }
        }
        visible.value = true
      }
      const resetFormData = () => {
        state.formData = {
          id: '',
          bank_id: null,
          bank_account_number: '',
          bank_account_name: '',
          bank_branch: '',
          default: 0
        }
      }
      const submitForm = async () => {
        if (!validate()) {
          return;
        }
        failed.value = false;
        const payload = {
          id: state.formData.id,
          userID: user.value.id,
          formData: {
            bank_id: state.formData.bank_id,
            bank_account_number: state.formData.bank_account_number,
            bank_account_name: state.formData.bank_account_name,
            bank_branch: state.formData.bank_branch,
            default: state.formData.default
          }
        }
        try {
          if(actions.value === 'edit') {
            await bankApis.updateBank(payload)
            toast.success(t('text.edit_successful'));
          } else {
            await bankApis.createBank(payload)
            toast.success(t("text.create_bank_success"));
            location.reload();
          }
          hide()
        } catch (error) {
          if (error.message == 'EUS011') {
            toast.error(t("code_errors."+error.message));
          }
          const messages = error.response.data.errors;
          messageError.value = _.mapValues(messages, (value) => {
            return value[0];
          });
        }
      }
      return {
        messageError,
        state,
        visible,
        hide,
        submitForm,
        setupDialog,
        banks,
        actions,
        failed,
        user,
      }
    }
  })
</script>
<style scoped>
  .checkbox >>> .form-item-label{
    display: inline-block;
    margin-right: 10px;
  }
  .checkbox >>> .form-item-input{
    display: inline-block;
    width: auto;
  }
</style>
